import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptors } from '@angular/common/http';
import { EnvironmentProviders, inject, Provider } from '@angular/core';
import { AuthService } from 'app/core/auth/auth.service';
import { coreInterceptor } from './core.interceptor';

export const provideCore = (): Array<Provider | EnvironmentProviders> =>
{
    return [
        provideHttpClient(withInterceptors([coreInterceptor])),
        {
            provide : HTTP_INTERCEPTORS,
            useValue: () => inject(AuthService),
            multi   : true,
        },
    ];
};
